<button [ngClass]="type==='group'?'common-button__icon-sm-background':'common-button__icon-sm-noborder'"
  [escape]="false"
  [pTooltip]="tooltipLaw.tooltip"
  tooltipPosition="top">
  <i class="lf-icon-legal-reference common-icon__md"
  (click)="openModalLaw($event)"></i>
</button>